import { StoryblokStudioTour } from './StoryblokStudioTour'

import { createStudioTour } from './__mocks__/studioTour'

export { createStudioTour }

// Re-export for backward compatibility
export const testBlok = createStudioTour()

export default StoryblokStudioTour
